// SAP's BOM data returns a DIMENSION label ("MASS", "LENGTH") where a unit
// is expected, while the material master carries the real UN/CEFACT code
// ("KGM", "MTR", "EA") - the one SAP actually posts stock in. Show both
// shapes the way the store team reads them on SAP's own screens.
const UNIT_LABELS = {
  MASS: "KG",
  WEIGHT: "KG",
  KGM: "KG",
  GRM: "G",
  LENGTH: "M",
  MTR: "M",
  MMT: "MM",
  CMT: "CM",
  LTR: "L",
  MTK: "SQM",
  TNE: "TON",
};

export const formatUnit = (u) => UNIT_LABELS[(u || "").toUpperCase()] || u || "";

export default formatUnit;
